import styled from 'styled-components';
import { Button, Form, Select } from 'antd';

import { AvatarImage } from '../../components/avatar/styled-components';
import { tangerineGradient, tangerineGradientRevert } from '../../styles';

const FItem = Form.Item;
const { Option } = Select;


export const FormItem = styled(FItem)`
  margin-bottom: 10px;
  label {
    color: ${props => props.theme.colors.fontSilverDark};
  }
  .ant-form-item-label {
    line-height: 2;
  }
  .ant-form-explain {
    padding-top: 10px;
  }
`;

export const SelectS = styled(Select)`
  font-size: 14px;
`;
export const StyledOption = styled(Option)`
  display: flex;
  flex-direction: row;
`;

export const Title = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  color: ${props => props.theme.colors.fontSilverDark};
  margin-bottom: 30px;  
`;

export const UserImageWrap = styled(AvatarImage)`
  margin-right: 15px;
`;

export const ButtonWrapper = styled.div`
  text-align: right;
`;

export const ButtonSave = styled(Button)`
  margin-top: 15px;
  ${tangerineGradient};
  color: ${props => props.theme.colors.white};
  width: 150px;
  height: 30px;  
  border: none;
  &:hover,
  &:focus {
    ${tangerineGradientRevert};
  }
`;

export const FieldWrapper = styled.div`
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/modals/assign-user-modal/styled-components.js